import logo from '@/assets/logo-footer.png'
import paymentVisa from '@/assets/payment-visa.svg'
import paymentMastercard from '@/assets/payment-mastercard.png'
import paymentAmex from '@/assets/payment-amex.png'
import paymentPix from '@/assets/payment-pix.png'
import paymentElo from '@/assets/payment-elo.png'
import { Linkedin } from 'lucide-react'

const Footer = () => {
  const currentYear = new Date().getFullYear()
  const whatsappNumber = '554137950568'

  return (
    <footer
      className="bg-secondary text-secondary-foreground"
      role="contentinfo"
      aria-label="Rodapé"
    >
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 md:gap-8">
          {/* Logo e Descrição */}
          <div className="col-span-2 md:col-span-1">
            <img
              src={logo}
              alt="FotoLivro Store"
              className="h-auto w-36 mb-3"
              loading="lazy"
            />
            <p className="text-lg font-serif italic text-foreground leading-relaxed">
              Suas memórias merecem ser tocadas.
            </p>
          </div>

          {/* Navegação */}
          <div>
            <h3 className="font-serif font-semibold mb-3 text-base">
              Navegação
            </h3>
            <ul className="space-y-2 text-sm text-secondary-foreground">
              <li>
                <a href="/#produtos" className="hover:underline">
                  Produtos
                </a>
              </li>
              <li>
                <a href="/faq" className="hover:underline">
                  FAQ
                </a>
              </li>
              <li>
                <a href="/contato" className="hover:underline">
                  Contato
                </a>
              </li>
              <li>
                <a href="/privacidade" className="hover:underline">
                  Privacidade
                </a>
              </li>
              <li>
                <a href="/proposito" className="hover:underline">
                  Propósito
                </a>
              </li>
            </ul>
          </div>

          {/* Contato e Redes Sociais */}
          <div>
            <h3 className="font-serif font-semibold mb-3 text-base">Contato</h3>
            <a
              href="mailto:atendimento@fotolivro.store"
              className="text-sm text-secondary-foreground hover:underline block mb-4"
            >
              atendimento@fotolivro.store
            </a>

            <h3 className="font-serif font-semibold mb-2 text-base">
              Redes Sociais
            </h3>
            <div className="flex space-x-2">
              <a
                href="https://instagram.com/fotolivrostore"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 transition-transform"
                aria-label="Instagram"
              >
                <svg
                  className="h-8 w-8"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    width="24"
                    height="24"
                    rx="6"
                    fill="url(#instagram-gradient-footer)"
                  />
                  <path
                    d="M12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5ZM12 14.25C10.758 14.25 9.75 13.242 9.75 12C9.75 10.758 10.758 9.75 12 9.75C13.242 9.75 14.25 10.758 14.25 12C14.25 13.242 13.242 14.25 12 14.25ZM16.5 8.35C16.5 8.843 16.093 9.25 15.6 9.25C15.107 9.25 14.7 8.843 14.7 8.35C14.7 7.857 15.107 7.45 15.6 7.45C16.093 7.45 16.5 7.857 16.5 8.35ZM19.45 9.25C19.394 8.087 19.134 7.051 18.289 6.206C17.444 5.361 16.408 5.101 15.245 5.045C14.052 4.985 9.948 4.985 8.755 5.045C7.592 5.101 6.556 5.361 5.711 6.206C4.866 7.051 4.606 8.087 4.55 9.25C4.49 10.443 4.49 14.557 4.55 15.75C4.606 16.913 4.866 17.949 5.711 18.794C6.556 19.639 7.592 19.899 8.755 19.955C9.948 20.015 14.052 20.015 15.245 19.955C16.408 19.899 17.444 19.639 18.289 18.794C19.134 17.949 19.394 16.913 19.45 15.75C19.51 14.557 19.51 10.443 19.45 9.25ZM17.733 17.027C17.488 17.644 17.011 18.121 16.394 18.366C15.438 18.794 13.169 18.707 12 18.707C10.831 18.707 8.562 18.794 7.606 18.366C6.989 18.121 6.512 17.644 6.267 17.027C5.839 16.071 5.926 13.802 5.926 12.633C5.926 11.464 5.839 9.195 6.267 8.239C6.512 7.622 6.989 7.145 7.606 6.9C8.562 6.472 10.831 6.559 12 6.559C13.169 6.559 15.438 6.472 16.394 6.9C17.011 7.145 17.488 7.622 17.733 8.239C18.161 9.195 18.074 11.464 18.074 12.633C18.074 13.802 18.161 16.071 17.733 17.027Z"
                    fill="white"
                  />
                  <defs>
                    <linearGradient
                      id="instagram-gradient-footer"
                      x1="0"
                      y1="0"
                      x2="24"
                      y2="24"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FD5949" />
                      <stop offset="0.5" stopColor="#D6249F" />
                      <stop offset="1" stopColor="#285AEB" />
                    </linearGradient>
                  </defs>
                </svg>
              </a>
              <a
                href={`https://wa.me/${whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 transition-transform"
                aria-label="WhatsApp"
              >
                <svg
                  className="h-8 w-8"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="24" height="24" rx="6" fill="#25D366" />
                  <path
                    d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a
                href="https://youtube.com/@fotolivrostore"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 transition-transform"
                aria-label="YouTube"
              >
                <svg
                  className="h-8 w-8"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="24" height="24" rx="6" fill="#FF0000" />
                  <path
                    d="M19.615 8.654c-.132-.53-.518-.946-1.037-1.085C17.656 7.25 12 7.25 12 7.25s-5.656 0-6.578.319c-.519.139-.905.555-1.037 1.085C4.25 9.598 4.25 11.563 4.25 11.563s0 1.964.135 2.909c.132.53.518.93 1.037 1.069.922.319 6.578.319 6.578.319s5.656 0 6.578-.319c.519-.139.905-.539 1.037-1.069.135-.945.135-2.909.135-2.909s0-1.965-.135-2.909zM10.5 13.688V9.438l4.375 2.125-4.375 2.125z"
                    fill="white"
                  />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/fotolivrostore/?viewAsMember=true"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 transition-transform bg-[#0A66C2] rounded-md p-1.5"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5 text-white" />
              </a>
            </div>
          </div>

          {/* Formas de Pagamento */}
          <div className="col-span-2 md:col-span-2">
            <h3 className="font-serif font-semibold mb-3 text-base">
              Formas de Pagamento
            </h3>
            <div className="flex flex-wrap gap-2 mb-2 items-center">
              <div
                className="bg-white rounded px-1.5 py-1 flex items-center justify-center h-8 w-12"
                title="Visa"
              >
                <img
                  src={paymentVisa}
                  alt="Visa"
                  className="h-4 w-auto object-contain"
                />
              </div>
              <div
                className="bg-white rounded px-1.5 py-1 flex items-center justify-center h-8 w-12"
                title="Mastercard"
              >
                <img
                  src={paymentMastercard}
                  alt="Mastercard"
                  className="h-5 w-auto object-contain"
                />
              </div>
              <div
                className="bg-white rounded px-1.5 py-1 flex items-center justify-center h-8 w-12"
                title="American Express"
              >
                <img
                  src={paymentAmex}
                  alt="American Express"
                  className="h-6 w-auto object-contain"
                />
              </div>
              <div
                className="bg-white rounded px-1.5 py-1 flex items-center justify-center h-8 w-12"
                title="Elo"
              >
                <img
                  src={paymentElo}
                  alt="Elo"
                  className="h-4 w-auto object-contain"
                />
              </div>
              <div
                className="bg-white rounded px-1.5 py-1 flex items-center justify-center h-8 w-12"
                title="Pix"
              >
                <img
                  src={paymentPix}
                  alt="Pix"
                  className="h-4 w-auto object-contain"
                />
              </div>
            </div>
            <p className="text-sm text-secondary-foreground">
              Pagamento 100% seguro •{' '}
              <strong>Frete grátis para todo o Brasil</strong>
            </p>
          </div>
        </div>

        {/* Rodapé inferior */}
        <div className="border-t border-secondary-foreground/30 mt-6 pt-4 flex flex-col md:flex-row justify-between items-center gap-2 text-sm text-secondary-foreground">
          <p>
            &copy; {currentYear} FotoLivro Store. Todos os direitos reservados.
          </p>
          <p className="text-center">
            <strong>PH Tecnologia LTDA</strong> | CNPJ: 40.524.684/0001-45 | Rua
            Imaculada Conceição, 1430, Prado Velho - Curitiba/PR
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
